import { useQuery, useMutation } from 'react-query'
import useStaleTimes from '../use-stale-times'
import useCacheKeys from '../use-cache-keys'
import moment from 'moment'
import urlGenerator from '../../utilities/api-url-generator'
import axiosWrapper from '../../utilities/axios-wrapper'

const useUserFacilitatorRatings = ({
    limit = 1,
    mode = 'open',
    userId,
    startDate = moment().subtract(1, 'weeks').format('YYYY-MM-DD')
} = {}) => {
    const staleTimes = useStaleTimes()
    const cacheKeys = useCacheKeys()

    const {
        data,
        isLoading, isFetching
    } = useQuery(
        [cacheKeys.SURVEYS, 'facilitator', userId, limit, mode, startDate],
        () => axiosWrapper.get(urlGenerator.userFacilitatorRatings({ userId }, { limit, mode, sd: startDate })),
        { enabled: userId, staleTime: staleTimes.MINUTE * 5 }
    )

    return {
        userFacilitatorRatings: data ? data.items : [],
        isLoading: isLoading || isFetching,
    }
}

export default useUserFacilitatorRatings
